import React, { useEffect, useState } from 'react';
import axios from '../utils/axios';
import LinkIcon from '@mui/icons-material/Link';
import MouseIcon from '@mui/icons-material/Mouse';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
const formatNumber = num =>
  typeof num === 'number' && !isNaN(num) ? num.toLocaleString("vi-VN") : "0";

const statItems = [
  {
    label: "Links",
    icon: <LinkIcon sx={{ color: "#2563eb", fontSize: 32, mr: 1 }} />,
    color: "#2563eb",
    key: "totalLinks"
  },
  {
    label: "Clicks",
    icon: <MouseIcon sx={{ color: "#10b981", fontSize: 32, mr: 1 }} />,
    color: "#10b981",
    key: "totalClicks"
  },
  {
    label: "Users",
    icon: <PeopleAltIcon sx={{ color: "#f59e0b", fontSize: 32, mr: 1 }} />,
    color: "#f59e0b",
    key: "totalUsers"
  }
];

export default function HomeStats() {
  const [stats, setStats] = useState({ totalLinks: 0, totalClicks: 0, totalUsers: 0 });

  useEffect(() => {
    axios.get('/statistics/home')
      .then(res => setStats(res.data || { totalLinks: 0, totalClicks: 0, totalUsers: 0 }))
      .catch(() => setStats({ totalLinks: 0, totalClicks: 0, totalUsers: 0 }));
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(90deg, #eef2ff 0%, #f0fdfa 100%)',
      padding: "18px 0 16px 0"
    }}>
      <style>{`
        .stats-title {
          font-weight: 900;
          font-size: 2rem;
          text-align: center;
          background: linear-gradient(90deg, #6366f1, #22d3ee, #f59e0b);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: 1.2px;
          margin-bottom: 10px;
          margin-top: 0;
        }
        .stat-group {
          display: flex;
          justify-content: center;
          gap: 36px;
          align-items: center;
          width: 100%;
        }
        .stat-item {
          display: flex;
          align-items: center;
          min-width: 130px;
          padding: 0 10px;
        }
        .stat-number {
          font-size: 2.1rem;
          font-weight: 800;
          margin-right: 6px;
        }
        .stat-label {
          font-size: 1.06rem;
          font-weight: 600;
          color: #333;
          opacity: 0.80;
        }
        @media (max-width: 600px) {
          .stat-group { gap: 12px; }
          .stat-number { font-size: 1.3rem;}
          .stats-title { font-size: 1.2rem;}
          .stat-label { font-size: 0.95rem;}
        }
      `}</style>

      <h2 className="stats-title">Tổng Liên Kết Được Tạo Ra</h2>
      <div className="stat-group">
        {statItems.map(item => (
          <div className="stat-item" key={item.key}>
            {item.icon}
            <span className="stat-number" style={{ color: item.color }}>
              {formatNumber(stats[item.key])}
            </span>
            <span className="stat-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
